import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { user } from './user';
import { UserService } from './user.service';
import { AlertService } from '../util/alert/alert.service';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { AppService } from '../app.service'
declare var Fingerprint2: any;

import { Widget } from '../dashboard/widget.model'
import { WidgetService } from '../dashboard/widget.service';
import { environment } from '../../environments/environment';
import * as Keycloak  from 'keycloak-js';
import { Subscription } from 'rxjs';
import { ConfigService } from '../util/config.service';
import { Constants } from '../util/const/constants';
import { KeycloakService } from '../util/keycloak.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
	myForm: FormGroup;
	fp: any;
	isLoading;
	@ViewChild('emailModel', { static: false }) emailModel: ModalComponent;
	@ViewChild('successModel', { static: false }) successModel: ModalComponent;
	@ViewChild('errorModel', { static: false }) errorModel: ModalComponent;
	public assessmentId: string = '';
	public type: string = '';
	public appConfig: any = JSON.parse(localStorage.getItem('appInfo'))
	public logoSrc: string = ''
	public loginLogoPath: string = environment.server_URL + '/images/login/'
	emailValidated = false
	loginBtnClicked = false;
	showEmptyMessage = false
	usernameErrorMessage: string = ""
	showPasswordField = false
	checkUsername = false
	subscription: Subscription;
	username: string = "";
	stateData: any;
	loginDisabled = false;
	loginReady = false;
	//keycloak
	/* keycloak = {
		  url: 'http://localhost:8081',
		  realm: 'myrealm',
		  clientId: 'cms-auth'
	  }; */
	  initOptions = {
		  onLoad: 'login-required',
		  checkLoginIframe: false
	  }
	loginCalled =false;
   keycloakInstance: any;
   

	constructor(private userService: UserService, private router: Router, private appService: AppService,
		private alertServices: AlertService, private widgetService: WidgetService, private activatedRoute: ActivatedRoute, private configService: ConfigService,private keycloakService : KeycloakService) {
		this.assessmentId = this.activatedRoute.snapshot.queryParams["assessmentId"];
		this.type = this.activatedRoute.snapshot.queryParams["type"];
		if (userService.isValidLoggedIn()) {
			if (this.assessmentId != "null" && this.assessmentId != null && this.assessmentId !== undefined &&
				this.type != "null" && this.type != null && this.type !== undefined) {
				this.router.navigateByUrl('/assessmentsignature?type=' + this.type + '&assessmentId=' + this.assessmentId);
			} else if (this.assessmentId != "null" && this.assessmentId != null && this.assessmentId !== undefined) {
				this.router.navigateByUrl('/selfassessment?assessmentId=' + this.assessmentId);
			} else {
				console.log("user is already logged in")
				this.router.navigateByUrl('/home');
			}
		} 
		if (this.userService.isSessionExpiredForSSO()){
			console.log("session expired for sso")
			// localStorage.setItem('ssoSuccess',"false")
			// localStorage.setItem('loginClicked', "false")
			const keepKeys = ['keycloak_config', 'appInfo'];

				// Backup their values
				const savedValues = {};
				keepKeys.forEach(key => {
					savedValues[key] = localStorage.getItem(key);
				});

				// Clear all localStorage
				localStorage.clear();

				// Restore the saved values
				Object.keys(savedValues).forEach(key => {
					localStorage.setItem(key, savedValues[key]);
				});

			this.router.navigateByUrl('/user/login');
			this.loginDisabled = false;
		} else {
			
			console.log("session not expired for sso")
		}

		if (this.appConfig.loginLogo != "") {
			this.logoSrc = this.loginLogoPath + '' + this.appConfig.loginLogo
		} else {
			this.logoSrc = 'assets/images/logo/axis_logo.png'
		}

	}

	onSubmit() {
		window.localStorage.clear()
		this.alertServices.clear()
		this.loginBtnClicked = true;
		this.isLoading = true;
		localStorage.setItem('appInfo', JSON.stringify(this.appConfig));
		const tempUser = new user(this.myForm.value.email, this.myForm.value.password);
		tempUser.deviceId = (<HTMLInputElement>document.getElementById('deviceId')).value;

		this.userService.validateUser(tempUser).subscribe(
			data => {
				// console.log('===data :' + JSON.stringify(data));
				this.isLoading = false;
				if (data.generateKeyCode === undefined) {
					if (data.token === undefined) {
						this.router.navigateByUrl('/user/login');
					} else {
						localStorage.setItem('token', data.token);
						localStorage.setItem('userId', data.userId);
						localStorage.setItem('userName', data.userName);
						localStorage.setItem('userFirstName', data.firstName)
						localStorage.setItem('expiredIn', data.expiredIn);
						localStorage.setItem('TimeZone', data.timeZone);
						// console.log('[onSubmit] (userRoles) ' + JSON.stringify(data.userRoles))
						// local storage can not store arrays need to sringify it
						if (this.assessmentId != "null" && this.assessmentId != null && this.assessmentId !== undefined &&
							this.type != "null" && this.type != null && this.type !== undefined) {
							this.router.navigateByUrl('/assessmentsignature?type=' + this.type + '&assessmentId=' + this.assessmentId);
							if (data.userRoles.length > 1) {
								localStorage.setItem('userRoles', JSON.stringify(data.userRoles));
							} else {
								localStorage.setItem('selectedUserRole', JSON.stringify(data.userRoles));
							}
						} else if (this.assessmentId != "null" && this.assessmentId != null && this.assessmentId !== undefined) {
							this.router.navigateByUrl('/selfassessment?assessmentId=' + this.assessmentId);
							if (data.userRoles.length > 1) {
								localStorage.setItem('userRoles', JSON.stringify(data.userRoles));
							} else {
								localStorage.setItem('selectedUserRole', JSON.stringify(data.userRoles));
							}
						} else if (data.userRoles.length > 1) {
							localStorage.setItem('userRoles', JSON.stringify(data.userRoles));
							this.router.navigateByUrl('/userrole');
						} else {
							localStorage.setItem('selectedUserRole', JSON.stringify(data.userRoles));
							// get assigned capability list
							let roleId = data.userRoles[0][0]
							// console.log('[userRoleId] ' + data.userRoles[0][0])
							if (localStorage.getItem('capability') == null) {
								this.userService.getAssignedCapabalityList(data.userRoles[0][1])
									.subscribe(
									data => {
										localStorage.setItem('widgetList', null);
										// get dashboard widgets
										this.widgetService.getDashboardWidgets(roleId)
									},
									error => {
									}
									);
							}
						}
					}
					// console.log('undefined');

				} else {
					if (data.generateKeyCode) {
						var url = '/user/keycode?userId=' + data.userId;
						console.log(url);
						if (this.assessmentId) {
							url += '&assessmentId=' + this.assessmentId
						}
						if (this.type) {
							url += '&type=' + this.type
						}
						this.router.navigateByUrl(url);
					}
				}
			},
			error => {
				this.loginBtnClicked = false;
				this.isLoading = false;
				this.alertServices.clear();
				const err = error.json();
				if (err.title === 'WRONGPASSWORD') {
					this.loginBtnClicked = false;
					this.alertServices.handleError(err);
					this.myForm.get('password').setValue('');
				} else if (err.title === 'INVALIDEMAIL') {
					this.loginBtnClicked = false;
					this.alertServices.handleError(err);
					this.myForm.reset();
				} else {
					this.myForm.reset();
				}
			}
		);
	}

	async ngOnInit() {		
		const KeycloakInitiated = localStorage.getItem('KeycloakInitiated');
		const keycode_cancelled = localStorage.getItem( 'keycodeCancelled');
		if(localStorage.getItem( 'loginClicked') == 'true'){
			this.loginDisabled = true;

		}
		// if(localStorage.getItem('keycloakAborted') == 'true') {
		// 	this.loginDisabled = false;
		// }
		// localStorage.setItem('loginClicked', "false")
		console.log("[loginComponent] :: ngOnInit():: KeycloakInitiated isssss  " + KeycloakInitiated)
    	// const keycode_cancelled = localStorage.getItem( 'keycloakAborted');
		this.myForm = new FormGroup({
			email: new FormControl(null, [
				Validators.required,
				Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
			]),
			password: new FormControl(null, Validators.required)
		});
		this.stateData = history.state;
		await this.configService.getConfigByName('keycloak_config',true);

    	this.loginReady = true;

	}

	ngAfterViewInit() {
		var options = { excludeCanvas: true }
		this.fp = new Fingerprint2(options);
		this.fp.get(function (result) {
			(<HTMLInputElement>document.getElementById('deviceId')).value = result;
		});
	}
	public async checkUserName() {
		console.log("[loginComponent] :: checkUserName():: " )
		this.username = this.myForm.value.email;
		if (this.username != null) {
			this.showEmptyMessage = false
		  var re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
		  let emailChecked = re.test(this.username);
		  if (emailChecked) {
			this.emailValidated = false;
			let deviceId = (<HTMLInputElement>document.getElementById('deviceId')).value;
			await this.userService.getUserAuthTypeByEmail(this.username,deviceId).subscribe(
			  async response => {
				// const returnedStatus = response.status


				if (response.payload != null){
				  let authtype = JSON.stringify(response.payload.authType)
				  let status = JSON.stringify(response.payload.status)
				  if(status == "1"){
				  console.log("[loginComponent] :: getUserAuthTypeByEmail():: authtype::" + authtype)
				  this.configService.setAuthType(authtype)
				  if (authtype == Constants.AUTH_TYPE.SSOUser) {
					this.showPasswordField = false;
					await this.keycloakLogin();
				  } else {
					this.emailValidated = true;
					this.showEmptyMessage = false;
                  	this.showPasswordField = true;
				  }
				} else if(status == "0"){
					this.emailValidated = false;
					this.showEmptyMessage = true;
					this.showPasswordField = false;
					this.loginDisabled = false;
					this.alertServices.error("Unauthorized User");
					this.myForm.reset();
				}

				} else{
					this.emailValidated = false;
				  this.showEmptyMessage = false;
              	  this.showPasswordField = false;
					this.loginDisabled = false;
					this.myForm.reset();
				}
				
			  }
			  ,
			  error => {
				this.emailValidated = false;
				this.showEmptyMessage = true;
				this.showPasswordField = false;
				this.loginDisabled = false;
				// this.usernameErrorMessage = "User does not exist"
				this.alertServices.error("User does not exist");
				this.myForm.reset();


			  }
			)
		  } else{
			this.emailValidated = false;
			this.showEmptyMessage = true;
			this.showPasswordField = false;
			this.loginDisabled = false;
			this.alertServices.error("Invalid email format");
			this.myForm.reset();
			return;
		  };
		  //call keycloak
	
	
		} else {
		  this.emailValidated = false;
		  this.showEmptyMessage = true;
		  this.showPasswordField = false;
		  this.loginDisabled = false;
		  this.alertServices.error("Email is required");
		  this.myForm.reset();
		}
	  }
	  async keycloakLogin() {
		console.log("[keycloakLogin] :: keycloakLogin():: ------1--------------::" )
		this.loginCalled = true;
		localStorage.setItem('loginClicked', "true")
		localStorage.setItem('keycloakAborted',"false")
		await this.keycloakInitialization();
	  }

	  async keycloakInitialization() {
		console.log("keycloakInitialization...");
		console.log("[keycloakInitialization] :: keycloakInitialization called----::" )
		try {

		  let keycloakConfig = JSON.parse(localStorage.getItem('keycloak_config'));

		  
		  let initOptions = {
			url: keycloakConfig.issuer,
			realm: keycloakConfig.realm,
			clientId: keycloakConfig.clientId,
			checkLoginIframe: false,
			onLoad: 'login-required',
			responseType: 'id_token token'
		  };
	 
		  let loginOptions = {
			loginHint: this.username
			
		  }



		if (this.keycloakInstance == null) {
			console.log("Keycloak instance is null, initializing...");
			this.keycloakInstance = await this.keycloakService.init();
			this.configService.setKeycloakInstance(this.keycloakInstance);
			if (this.keycloakInstance.authenticated) {
				console.log("User authenticated!");}
		  }
		  
		  console.log("Keycloak instance after init:", this.keycloakInstance);
		  console.log("[keycloakInitialization] :: keycloakInitialization called-2---::" )


		
			await this.keycloakInstance.init({
				
				onLoad: 'check-sso', // 🔑 DO NOT auto-redirect to login
 				silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
				
			
			}).success(async (auth) => {
				console.log("[keycloakInitialization] :: keycloakInitialization called-4---::"+JSON.stringify(auth) )
      	if (!auth) {
        
			console.log("not auth===");
			let KeycloakInitiated = localStorage.getItem('KeycloakInitiated');
			let KeycloakAborted = localStorage.getItem('keycloakAborted');
			let keycode_cancelled = localStorage.getItem('keycodeCancelled');
			let keycloak_authenticated = localStorage.getItem('keycloakAuthenticated');
			const currentUrl = this.router.url;
			if ((KeycloakInitiated == "true" && KeycloakAborted == "true") || keycode_cancelled == "true" ||
			keycloak_authenticated == "true") {
				
				//do not call  keyclaok login
				this.router.navigateByUrl('/user/login');

			} else if(localStorage.getItem('ssoSuccess') == 'false'){
				this.router.navigateByUrl('/user/login');
				this.loginDisabled = false;
				// Keys you want to keep
				const keepKeys = ['keycloak_config', 'appInfo'];

				// Backup their values
				const savedValues = {};
				keepKeys.forEach(key => {
					savedValues[key] = localStorage.getItem(key);
				});

				// Clear all localStorage
				localStorage.clear();

				// Restore the saved values
				Object.keys(savedValues).forEach(key => {
					localStorage.setItem(key, savedValues[key]);
				});
				
			
			} else {


				localStorage.setItem('ssoSuccess', "false")
			  await this.keycloakInstance.login({
				loginHint: this.username})
				localStorage.setItem('KeycloakInitiated',"true")
			}
			// localStorage.setItem('ssoSuccess', "true")
			localStorage.setItem('keycloakAborted',"true")
			localStorage.setItem('keycodeCancelled',"false")
			localStorage.setItem('keycloakAuthenticated',"false")
		  } else {
			console.log("Authenticated");
			this.configService.setKeycloakInstanceIdToken(this.keycloakInstance.idToken);
			let tokenParsed = "";
			if (this.keycloakInstance.tokenParsed) {
				tokenParsed = this.keycloakInstance.tokenParsed
			  } else {
				 tokenParsed = "false"
			  }
			const keycloakData = {
			  token: this.keycloakInstance.token,
			  refreshToken: this.keycloakInstance.refreshToken,
			  idToken: this.keycloakInstance.idToken,
			  tokenParsed : tokenParsed,
			  realm : this.keycloakInstance.realm
			};
			localStorage.setItem('keycloakInstance',JSON.stringify(keycloakData));
			localStorage.setItem('ssoSuccess', "true")
			localStorage.setItem('keycloakAborted',"false")
			localStorage.setItem('keycloakAuthenticated',"true")
			localStorage.setItem('authType',Constants.AUTH_TYPE.SSOUser)
			//this.keycloakInstance.login(loginOptions);
			//var userProf = await keycloak.loadUserProfile();
	
			var loadUserInfo = await this.keycloakInstance.tokenParsed;
			console.log("loasUserInfo:"+loadUserInfo.email);
			var clientSecret = await this.keycloakInstance.clientSecret;
			var userInfox = await this.keycloakInstance.userInfo;
			var token = await this.keycloakInstance.token;
			//var userInfo = await keyCloakService.keycloak;
	
			var returnedStatus
			let deviceId = (<HTMLInputElement>document.getElementById('deviceId')).value;
			this.userService
			  .validateSSOUser(
				loadUserInfo.email,token, deviceId
			  )
			  .subscribe(
				data => {
					// console.log('===data :' + JSON.stringify(data));
					this.isLoading = false;
					if (data.generateKeyCode === undefined) {
						if (data.token === undefined) {
							this.router.navigateByUrl('/userrole');
						} else {
							localStorage.setItem('token', data.token);
							localStorage.setItem('userId', data.userId);
							localStorage.setItem('userName', data.userName);
							localStorage.setItem('userFirstName', data.firstName)
							localStorage.setItem('expiredIn', data.expiredIn);
							localStorage.setItem('TimeZone', data.timeZone);
							// console.log('[onSubmit] (userRoles) ' + JSON.stringify(data.userRoles))
							// local storage can not store arrays need to sringify it
							if (this.assessmentId != "null" && this.assessmentId != null && this.assessmentId !== undefined &&
								this.type != "null" && this.type != null && this.type !== undefined) {
								this.router.navigateByUrl('/assessmentsignature?type=' + this.type + '&assessmentId=' + this.assessmentId);
								if (data.userRoles.length > 1) {
									localStorage.setItem('userRoles', JSON.stringify(data.userRoles));
								} else {
									localStorage.setItem('selectedUserRole', JSON.stringify(data.userRoles));
								}
							} else if (this.assessmentId != "null" && this.assessmentId != null && this.assessmentId !== undefined) {
								this.router.navigateByUrl('/selfassessment?assessmentId=' + this.assessmentId);
								if (data.userRoles.length > 1) {
									localStorage.setItem('userRoles', JSON.stringify(data.userRoles));
								} else {
									localStorage.setItem('selectedUserRole', JSON.stringify(data.userRoles));
								}
							} else if (data.userRoles.length > 1) {
								localStorage.setItem('userRoles', JSON.stringify(data.userRoles));
								this.router.navigateByUrl('/userrole');
							} else {
								localStorage.setItem('selectedUserRole', JSON.stringify(data.userRoles));
								// get assigned capability list
								let roleId = data.userRoles[0][0]
								// console.log('[userRoleId] ' + data.userRoles[0][0])
								if (localStorage.getItem('capability') == null) {
									this.userService.getAssignedCapabalityList(data.userRoles[0][1])
										.subscribe(
										data => {
											localStorage.setItem('widgetList', null);
											// get dashboard widgets
											this.widgetService.getDashboardWidgets(roleId)
										},
										error => {
										}
										);
								}
							}
						}
						// console.log('undefined');
	
					} else {
						if (data.generateKeyCode) {
							var url = '/user/keycode?userId=' + data.userId;
							if (this.assessmentId) {
								url += '&assessmentId=' + this.assessmentId
							}
							if (this.type) {
								url += '&type=' + this.type
							}
							this.router.navigateByUrl(url);
						}
					}
				},
				error => {
					this.isLoading = false;
					this.alertServices.clear();
					const err = error.json();
					if (err.title === 'INVALIDEMAIL') {
						this.alertServices.handleError(err);
						this.myForm.reset();
					} else {
						this.myForm.reset();
					}
				}
			  )
		  }
		  ;
		}).error((x) => {
		  this.alertServices.error("Authentication Failed");
		  console.error("Keycloak Authentication Failed"+x);
		}); 
	   
		console.log("this.keycloakInstance.KeycloakAdapter----------"+this.keycloakInstance.KeycloakAdapter);

	
	
		  console.log("[keycloakInitialization] :: keycloakInitialization called-3---::" )
		  
		} catch (error) {
		  this.alertServices.error("Internal Server Error");
		  console.error("keycloakInitialization:"+error);
		}
	  }
	
	
	clickForgotpasswordLink() {
		if (this.myForm.value.email == null) {
			this.emailModel.open();
		} else {
			this.isLoading = true;
			const tempUser = new user(this.myForm.value.email);
			this.userService.validateEmail(tempUser)
				.subscribe(
				data => {
					this.isLoading = false;
					this.successModel.open();
				},
				error => {
					if (error.status === 201) {
						this.isLoading = false;
						this.errorModel.open();
					} else if (error.status === 401) {
						this.isLoading = false;
						this.errorModel.open();
					} else {
						this.isLoading = false;
						this.errorModel.open();
					}
				}
				);
			this.myForm.reset();
		}
	}

	async ngAfterContentInit(){
		console.log('--ngAfterContentInit----start-----')
		console.log('--ngAfterContentInit----this.stateData-----'+JSON.stringify(this.stateData))
		let stateData = JSON.parse(JSON.stringify(this.stateData))
		let keycodeError = "";
		if ('keycodeError' in stateData) {
		   keycodeError = JSON.stringify(stateData.keycodeError)
		}
	   
		//console.log('--ngAfterContentInit----keycodeError------'+keycodeError)
		if (this.keycloakInstance == undefined) {
		  console.log('--ngAfterContentInit----undefined------')
		  let loginclicked = localStorage.getItem('loginClicked');
		  let ssoSuccess = localStorage.getItem('ssoSuccess');
		 if(loginclicked == "true" && !(keycodeError == "401")){

			console.log('--ngAfterContentInit----keycloakInitialization------')
			this.keycloakInitialization()
		//   } else if(ssoSuccess == "false" && loginclicked == "true"){
		// 	console.log('--ngAfterContentInit----keycloakInitialization---else if---')
		// 	this.router.navigateByUrl('/user/login');
		// 	// this.keycloakInitialization()
		  } else{
			// this.router.navigateByUrl('/user/login');
			console.log('--ngAfterContentInit----keycloakInitialization---else---')
		  }
		} else {
		  console.log('--ngAfterContentInit----defined------')
		  let loggedIn = await this.keycloakInstance.isLoggedIn;
		  if (loggedIn == undefined) {
			this.keycloakLogin();
		  } else {
			await this.keycloakInstance.isLoggedIn().then(async loggedInFunc => {
			  if (loggedInFunc) {
				var loadUserInfo = await this.keycloakInstance.tokenParsed;
			  } else {
			  }
			})
		  } 
		}
	  }
	  async checkAuthenticationStatus() {
		const loggedIn = await this.keycloakInstance.isLoggedIn();
		console.log("Is user logged in? ", loggedIn);
	}
	

}
